import storage from '@/utils/storage.js'

const storageTitle = 'airenz-web-';
const TOKEN_KEY = storageTitle + 'token';
const REFRESHTOKEN_KEY = storageTitle + 'refreshToken';

const isLogin = () => {
  return !!localStorage.getItem(TOKEN_KEY);
  // return true
};

const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

const setToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

const getRefreshToken = () => {
  return localStorage.getItem(REFRESHTOKEN_KEY);
};

const setRefreshToken = (refreshToken) => {
  localStorage.setItem(REFRESHTOKEN_KEY, refreshToken);
};

const removeRefreshToken = () => {
  localStorage.removeItem(REFRESHTOKEN_KEY);
};

const logout = ()=>{
  storage.clear()
  storage.clear('storage')

  window.location.href = import.meta.env.BASE_URL + 'login'
}

export {
  isLogin,
  getToken,
  setToken,
  removeToken,
  getRefreshToken,
  setRefreshToken,
  removeRefreshToken,
  logout
};
